import {
  ApiCtx,
  call,
  Next,
  put,
  select,
  sleep,
  take,
  takeEvery,
  takeLeading,
  updateStore,
} from "starfx"; // < init the next job;

import { dateToSqlDate, ensureArray } from "@app/service/helpers";
import { db as workerDb } from "@app/stateCommon/idbSchema";
import { schemaB } from "@app/stateCommon/schemaBlue";
import { sfxFetchMonede } from "@app/statefx/xThunks/currencyRates";
import { sfxGetInvoiceIssuers } from "@app/statefx/xThunks/ds-profile";

import { identityACtx, isErr, isOk, runThunk, safeLast } from "../helpers";
import { vacacheApiFactory } from "../routines/bootcommander";
import { schema } from "../schema";
import { TWhoami } from "../schema/app.def";
import { selectorWorkerGxDBName } from "../selectors/app.sel";
import { initGxWorker } from "../workers";
import { getWorker } from "../workers/gxworker-factory";
// import { getPxWorker } from "../workers/pxworker-factory";
import { xApi, xThunk, xWorker } from "../xapis";
import { sfxNotify } from "./notify";
import { aquireLock, aquireLockThunk, releaseLock } from "./prc-lock";

import type { TAppJob } from "../schema/app-jobs.def";
import type { ThunkCtx, TEmitent, TPostBackType } from "@app/types/insider";
import type { IGroupMember } from "@app/types";
type TFetchDbInWorker = {
  postBack: boolean;
  pbkType: TPostBackType;
  workerEndpoint: string;
  postBackKey?: string;
  hashes?: string[][];
};
export function WorkerStorage(store) {
  if (!store) {
    console.error("store not found 3");
    return;
  }
  const db = workerDb(store);
  return db;
}
export const fetchDatabaseInWorker = xWorker.post<TFetchDbInWorker>(
  "/runner/fetchdatabase",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const { postBack, workerEndpoint } = ctx.payload;
    const who = yield* select(schema.whoami.select);
    const hasFiscalRights = who.DreptSuprem || who.DreptFacturare;

    if (hasFiscalRights) {
      const emintents = yield* select(schema.invoiceIssuer.selectTableAsList);
      const emitentRecords = emintents.filter((e: TEmitent) => e?.CIF);
      const thisLogin = yield* select(schema.whoami.select);
      const thisLoginId = thisLogin?.AmaId;
      const _startDate = yield* select(schema.app.select);
      const startDate = _startDate?.absolutestart;
      const env = process.env.REACT_APP_MODE;
      const syncCode = `/DONE/${workerEndpoint}`;
      const pbkType = ctx.payload.pbkType;
      const postBackKey = ctx.payload.postBackKey;
      const hashPairs = ctx.payload.hashes;
      const qpArray = emitentRecords.map((emitent) => {
        return {
          _cif: emitent.CIF,
          _startDate: startDate,
          _syncCode: null,
          ama: thisLoginId,
          cancel: false,
          emitent: emitent.ABR,
          env: env,
          postBackKey: postBackKey || "",
          thisAmaId: thisLoginId,
          watch: false,
        };
      });
      const params = new URLSearchParams({
        amaid: `${thisLoginId}`,
        emitent: "*",
        env,
        pbkType,
        postBack: postBack,
        postBackKey: postBackKey || "",
        start: dateToSqlDate(new Date(startDate)),
        syncCode,
      });
      ctx.request = ctx.req({
        body: JSON.stringify({ data: qpArray, hashPairs }),
        method: "POST",
        url: `/runner/${workerEndpoint}?${params}`,
      });
    }
    yield* next();
  }
);

/* -------------------------------------------------------------------------- */
/*                                 the startup                                */
/* -------------------------------------------------------------------------- */
type TBootRehydrate = { what: "spv" | "fiscal"; amaid: number };
/// don't!
export const __deprecate__workerReHydrate = xWorker.get<TBootRehydrate>(
  "/runner/rehydrate",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    // const { what, amaid } = ctx.payload;
    // ctx.request = ctx.req({
    //   url: `/runner/rehydrate?amaid=${amaid}&what=${what}`,
    // });
    yield* next();
  }
);

export const sfxDataBoot = xApi.get(
  "/sfx/dataBoot",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      url: "/assets/whoami",
    });
    yield* next();
    const unPacked = yield* safeLast(identityACtx(ctx));
    if (isErr(unPacked)) {
      yield* runThunk(sfxNotify, {
        message: `EROARE LA LOGIN: ${unPacked.error.message}`,
        type: "error",
        duration: 7000,
        position: "top",
      });
      return;
    }
    if (isOk(unPacked)) {
      const [who] = unPacked.value as TWhoami[];
      yield* schema.update(schema.whoami.set(who));
    }
  }
);

export const getAbsoluteStartDate = xApi.get(
  "sfx/select/ss_mywork_criteria",
  function* (ctx: ApiCtx, next: Next) {
    // it gets the amaId from the session //
    ctx.request = ctx.req({
      url: "/select/ss_mywork_criteria",
    });
    yield* next();
    const unPacked = yield* safeLast(identityACtx(ctx));
    if (isErr(unPacked)) {
      console.log("error #334", unPacked.error);
    }
    if (isOk(unPacked)) {
      const group = ensureArray(unPacked.value).find(
        (x) => x.USER_GROUP === "GROUP"
      );
      if (group) {
        const startdate = group.START_DATE;
        if (startdate) {
          // inject starfx date//
          yield* schema.update(
            schema.app.update({ key: "absolutestart", value: startdate })
          );
        }
      }
    }
  }
);
export const clearAppJobs = xThunk.create(
  "/sfx/clearAppJobs",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    const fullIdbName = yield* select(selectorWorkerGxDBName);
    const db = yield* call(() => WorkerStorage(fullIdbName));
    //delete table appJobs
    yield* call(() => db.clear("appJobs"));
    yield* next();
  }
);

export const clearOldHashes = xWorker.get(
  "/runner/clearOldHashes",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    yield* next();
  }
);

//(!!!)
export const vacacheCommander = xThunk.create<string[]>(
  "/sfx/vacacheCommander",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    const messageStack = ctx.payload;
    const initial = messageStack.length;
    for (let message of messageStack) {
      //some advertising
      const sizeLeft = initial - messageStack.indexOf(message);
      yield* updateStore([
        schema.loaderText.set(
          `cache ${Math.floor(((initial - sizeLeft) / initial) * 100)} %`
        ),
        schema.loaderBootProgress.set(
          Math.floor(((initial - sizeLeft) / initial) * 100)
        ),
        schema.loaderBootText.set("validare cache"),
      ]);

      //if is the last, mark it, we need to know when it ends
      if (message === messageStack[messageStack.length - 1]) {
        message = message.replace("vacache", "vacache/last");
      }
      // the call
      const gxWorker = getWorker();
      yield* call(() => gxWorker.postMessage(message));
      // yield* sleep(128);
      yield* sleep(32);
    }
    yield* next();
  }
);

//(!!!)
export const runBootSequence__ = xWorker.get(
  "/runner/bootup",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const locked = yield* select(schema.lock.select);
    if (locked) {
      // this should not happen
      console.log("locked in boot sequence", locked);
      return;
    }
    yield* aquireLock("bootup");

    ctx.request = ctx.req({
      url: "/sfx/reenter", //ignore carrier //
    });
    const a = yield* call(clearAppJobs.run());
    const aa = yield* call(clearAppJobs.run());

    console.log("appJobs cleared");
    const appJobs = yield* select(schema.appJobs.selectTable);
    console.log("proof: appJobs=", appJobs);

    const fullIdbName = yield* select(selectorWorkerGxDBName);
    const db = yield* call(() => WorkerStorage(fullIdbName));
    const appJobsDb = yield* call(() => db.getAll("appJobs"));
    console.log("proof: appJobsDb=", appJobsDb);

    if (process.env.REACT_APP_APP !== "JGAP") {
      const b = yield* call(() => sfxDataBoot.run());
    }
    const c = yield* call(() => getAbsoluteStartDate.run());
    const d = yield* call(() => sfxFetchMonede.run());
    const e = yield* call(() => sfxGetInvoiceIssuers.run());

    const messageStack = yield* call(vacacheApiFactory);

    const f = yield* call(() => vacacheCommander.run(messageStack));

    yield* call(() => recacheDb.run(messageStack));
    yield* next();
    yield* call(() => clearOldHashes.run());
    yield* releaseLock();
  }
);

// note: this version is faster and smarter.
// it breaks on a post message at the end
export const runBootSequence = xWorker.get(
  "/runner/bootup/deferringshards", //fast
  { supervisor: takeEvery },
  function* (ctx: ApiCtx, next: Next) {
    console.log("runBootSequence");
    const locked = yield* select(schema.lock.select);
    if (locked) {
      // this should not happen
      console.log("locked in boot sequence", locked);
      return;
    }
    yield* call(aquireLockThunk.run({ op: "bootup" }));

    ctx.request = ctx.req({
      url: "/sfx/reenter", //ignore carrier //
    });
    yield* call(() => clearAppJobs.run());
    yield* schema.update(schema.loaderBootProgress.set(0));
    yield* schema.update(schema.loaderText.set("initializare"));
    yield* schema.update(schema.loaderBootText.set("initializare"));

    if (process.env.REACT_APP_APP !== "JGAP") {
      const b = yield* call(() => sfxDataBoot.run());
    }
    yield* call(() => sfxGetInvoiceIssuers.run());
    yield* call(() => getAbsoluteStartDate.run());
    yield* call(() => sfxFetchMonede.run());
    const messageStack = yield* call(() => vacacheApiFactory());
    yield* call(() => queryShards.run(messageStack));
    yield* next();
    yield* call(() => clearOldHashes.run());
    // yield* releaseLock();
    // const result = yield* safeLast(identityACtx(ctx));
    // console.log("result", result);
  }
);

/* -------------------------------------------------------------------------- */

type TWorkerDelOp = {
  table: string;
  index: string;
  lower: string;
  upper: string;
};
export const wDel = xWorker.delete<TWorkerDelOp>(
  "/runner/del",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const { table, index, lower, upper } = ctx.payload;
    const params = new URLSearchParams({
      table,
      index,
      lower,
      upper,
    });
    ctx.request = ctx.req({
      url: `/runner/del`,
      method: "DELETE",
      body: JSON.stringify({ data: params }),
    });
    yield* next();
  }
);

export const wDrop = xWorker.get(
  "/runner/drop",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    yield* next();
    const res = yield* safeLast(identityACtx(ctx));
    let msg, type;
    if (isErr(res)) {
      msg = `EROARE LA DROP: ${res.error.message}`;
      type = "error";
    }
    if (isOk(res)) {
      msg = `DROP REUSIT`;
      type = "success";
    }
    yield* runThunk(sfxNotify, {
      message: msg,
      type,
      duration: 2000,
      position: "bottom",
    });
  }
);

export const wClearCache = xWorker.get(
  "/runner/clearHashes",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    yield* next();
  }
);

export const workerReboot = xWorker.get(
  "/runner/reboot",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    yield* call(runBootSequence.run());
    yield* next();
  }
);

export const workerRebootClean = xWorker.get(
  "/runner/rebootClean",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    yield* call(wClearCache.run());
    yield* sleep(300);
    yield* call(runBootSequence.run());
    yield* next();
  }
);

export const workerDropDbReboot = xWorker.get(
  "/runner/dropDbReboot",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const fullIdbName = yield* select(selectorWorkerGxDBName);
    yield* call(wDrop.run());
    yield* sleep(700);
    yield* call(() => initGxWorker(fullIdbName));
    ///

    yield* call(runBootSequence.run());
    yield* next();
  }
);

export const dbMaintenaceInit = xWorker.get(
  "/runner/dbMaintenaceInit",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    yield* schema.update(schema.lock.set("$$csdbinit$$"));
    yield* next();
  }
);

export const dataCmder = xThunk.create<Record<string, string>>(
  "/sfx/dataCmder",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    const { reboot } = ctx.payload;
    if (reboot === "L") {
      yield* call(workerReboot.run());
    }
    if (reboot === "B") {
      yield* call(workerRebootClean.run());
    }
    if (reboot === "D") {
      yield* call(workerDropDbReboot.run());
    }
    yield* next();
  }
);

function* waitSelectorKey(selector, key) {
  const data = yield* select(selector);
  if (data?.[key]) {
    return;
  }
  while (true) {
    yield* take("*");
    const data = yield* select(selector);
    if (data?.[key]) {
      return;
    }
  }
}

function* waitforMinSize(selector, size) {
  const data = yield* select(selector);
  let i = 0;
  console.log("size", size);
  console.log("Object.keys(data).length", Object.keys(data).length);
  if (Object.keys(data).length >= size) {
    return;
  }
  while (true) {
    yield* take("*");
    const data = yield* select(selector);
    console.log("Object.keys(data).length", i++, Object.keys(data).length);
    if (Object.keys(data).length >= size) {
      console.log("done, exit waitforMinSize");
      return;
    }
  }
}

const fetchRebuildingCache = xWorker.post<TAppJob>(
  "/wait/fetchRebuildingCache",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      body: JSON.stringify(ctx.payload),
    });
    yield* next();
    /*
    when done delete the old shard and update with the new one from idb,
    which is done by calling /worker/idbready action from worker.
    it also updates the hashes table with the new hash
    --
    now we have to do the cleanup
    */
    const frcResult = yield* safeLast(identityACtx(ctx));
    if (isErr(frcResult)) {
      console.log("fetchRebuildingCache error", frcResult.error);
      console.log("errored on ", ctx.payload);
      console.log("some text written using newovim");
    } else {
      yield* updateStore(schema.appJobs.remove([ctx.payload.ord]));
    }
  }
);

export const recacheDb = xThunk.create<string[]>(
  "/sfx/recacheDb",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    const messageStack = ctx.payload;
    console.log("messageStack", messageStack);
    yield* waitforMinSize(schema.appJobs.selectTable, messageStack.length);
    const toProcess_ = yield* select(schema.appJobs.selectTable);
    // delete inactive jobs
    const inactiveKeys = Object.entries(toProcess_)
      .filter(([, x]) => !(x as TAppJob).active)
      .map(([k]) => k);
    yield* updateStore(schema.appJobs.remove(inactiveKeys));

    const reallyToProcess = Object.values(toProcess_).filter(
      (x: TAppJob) => x.active
    );
    // console.log('reallyToProcess', reallyToProcess.length);

    let size = Object.keys(reallyToProcess).length;
    const initial = size;

    while (size > 0) {
      yield* updateStore([
        schema.loaderText.set(
          `indexare ${Math.floor(((initial - size) / initial) * 100)} %`
        ),
        schema.loaderBootProgress.set(
          Math.floor(((initial - size) / initial) * 100)
        ),
      ]);
      yield* sleep(10);

      const toProcess = yield* select(schema.appJobs.selectTable);
      const minKey = Math.min(...Object.keys(toProcess).map((k) => +k));
      const job = toProcess[minKey];

      if (job?.active) {
        // console.log('running', job._hkey);
        const tableName = (job._hkey || "").split(":")[0];
        const label = schemaB[tableName]?.label || tableName;
        yield* updateStore(schema.loaderBootText.set(`${label}`));

        yield* call(() => fetchRebuildingCache.run(job));
      }

      yield* updateStore(schema.appJobs.remove([minKey]));
      yield* sleep(10);
      size = Object.keys(toProcess).length;
    }

    if (process.env.NODE_ENV === "development") {
      console.log("[dev.] done with recache");
    }

    const fullIdbName = yield* select(selectorWorkerGxDBName);
    const db = yield* call(() => WorkerStorage(fullIdbName));
    yield* call(() => db.clear("appJobs"));
    yield* next();
  }
);

// export const afterSpvUpdateRefresh  ....
export const queryShards = xWorker.post<string[]>(
  "/runner/queryShards",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      method: "POST",
      url: `/runner/queryShards`,
      body: JSON.stringify(ctx.payload),
    });
    yield* next();
  }
);
